import { Tefl } from '../../lib/types/models/tefl/tefl'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getTefl(id: number, olId: number) {
  return restApiClient.url(constructApiUrl(API.tefl.get.url, { id, olId })).get<Tefl>()
}
